import React, { useEffect, useState } from "react";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faDeleteLeft,
  faEdit,
  faLocationDot,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";

// hooks
import useAuth from "../../hooks/useAuth";
// redux
import { dispatch, useDispatch, useSelector } from "../../redux/store";
import AddSupplierLocation from '../../components/_product/Modal/AddSupplierLocation';
import AddCustomerLocation from "./AddCustomerLocation";
import { deleteSupplierLocation, resetLoading, saveSupplierLocation } from "../../redux/slices/user";
import Swal from "sweetalert2";
import { getAddress } from "../../redux/slices/Customer";
//------------------------------------------------------

const SupplierAddresses = ({ locationType, name, addresses ,handleEdit, warning}) => {

  const [showBilling, setShowBilling] = useState(false);
  const [addressType, setAddressType] = useState("shipping");
  const [editAddresses, setEditAddresses] = useState("");
  const {isLocationDelete} = useSelector(state => state.user)
  const {user} = useAuth()

  useEffect(() => {
    setAddressType(locationType);
  }, []);


  const hanldeEditBillingOpen = (bItem) => {
    setEditAddresses(bItem);
    setShowBilling(true);
  }

  const hideModal = () => {
    setShowBilling(false);
  };

  


  const swalWithBootstrapButtons = Swal.mixin({
    customClass: {
      cancelButton: "btn btn-danger mx-2",
      confirmButton: "btn btn-primary mx-2", 
    },
    buttonsStyling: false,
  });

  const handleDeleteAddress = (location_id, isDefault) => {
    if (isDefault === 1) {
      Swal.fire({
        icon: 'warning',
        text : "Cannot delete default address!",

      })
      warning(true)
        return
    }
    else{
      swalWithBootstrapButtons.fire({
        icon: 'warning',
        text : "Do you want to delete address?",
        showCancelButton: true,
        confirmButtonText: 'Delete',
        reverseButtons : true
      })
      .then((result) => {
        if (result.isConfirmed) {
            dispatch(deleteSupplierLocation(location_id));
            Swal.fire({
              text : "Location deleted successfully!",
              icon : "success"
            })
        }
      })
      return
    }
  }

  
  useEffect(() => {
    dispatch(getAddress({ user_id: user.id }));
    dispatch(resetLoading());
  }, [isLocationDelete])

  return (
    <>
      {addresses?.length > 0 &&
        addresses.map((bItem, bIndex) => {
          return (
            <React.Fragment key={bIndex}>
              <div className="col-lg-6">
                <div className="myaccount-content mb-3">
                  <div className="billing_address d-flex flex-column">
                      <div className="d-flex justify-content-end edit-btn">                        
                       { bItem.is_default == 1 && <h5>Default</h5>}
                       <div className="ms-auto">
                       <button
                            type="button"
                            className="btn btn-sm btn-primary mx-1"
                            onClick={() => hanldeEditBillingOpen(bItem)}
                            title="Edit"
                          >
                            <FontAwesomeIcon icon={faEdit} />
                          </button>
                          <button
                            type="button"
                            className="btn btn-sm btn-danger mx-1"
                            onClick={() => handleDeleteAddress(bItem.id, bItem.is_default, bItem)}
                            title="Delete"
                            color="red"
                          >
                            <FontAwesomeIcon icon={faTrash} color={"white"}/>
                          </button>
                       </div>
                        
                      </div>
                      <hr />
                      <div>
                      <p>
                      {bItem.address} <br /> {bItem.city},{" "}
                      {bItem.state.trans.name}, {bItem.country.trans.name},{" "}
                      {bItem.pincode}
                    </p>
                    <p>
                      Mobile: +{bItem.phoneCode} {bItem.phone}
                    </p>
                      </div>
                   
                  </div>
                </div>
              </div>     
              {showBilling &&  (
                <AddSupplierLocation
                  locationType={addressType}
                  handleClose={hideModal}
                  locationDetails = {editAddresses}
                />
              )}        
            </React.Fragment>
          );
        })}
    </>
  );
};

export default React.memo(SupplierAddresses);
